import {JsonProperty} from "@outfoxx/jackson-js";

export class SubscribeKey {
    @JsonProperty()
    readonly moduleName: string;
    @JsonProperty()
    readonly entityName: string;
    @JsonProperty()
    readonly entityId: string;
    @JsonProperty()
    readonly action: string;

    constructor(moduleName: string, entityName: string, entityId: string, action: string) {
        this.moduleName = moduleName;
        this.entityName = entityName;
        this.entityId = entityId;
        this.action = action;
    }
}
